exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-wines-index-tsx": () => import("./../../../src/pages/wines/index.tsx" /* webpackChunkName: "component---src-pages-wines-index-tsx" */),
  "component---src-pages-wines-wines-json-slug-tsx": () => import("./../../../src/pages/wines/{WinesJson.slug}.tsx" /* webpackChunkName: "component---src-pages-wines-wines-json-slug-tsx" */)
}

